import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DmcOverrideStateService } from '@core/state';

const DMC_SCOPED_PREFIX = '/dmc-dashboard/';

/** Returns the admin's full DMC list, so it must stay unscoped. */
const EXCLUDED_ROUTES = ['/dmc-dashboard/dmcs'];

/**
 * Attaches `x-dmc-override` so an admin can browse another DMC's dashboard.
 *
 * Omitting the header makes the API fall back to the DMC in the user's token,
 * which is what partners always want, so only admins ever send it.
 */
export const dmcOverrideInterceptor: HttpInterceptorFn = (req, next) => {
  const dmcOverride = inject(DmcOverrideStateService);

  const isDmcScoped =
    req.url.includes(DMC_SCOPED_PREFIX) &&
    !EXCLUDED_ROUTES.some((route) => req.url.includes(route));

  if (!isDmcScoped) {
    return next(req);
  }

  const dmcId = dmcOverride.dmcId();

  if (!dmcId || !dmcOverride.isAdmin()) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'x-dmc-override': dmcId } }));
};
